import type { UserData } from '../types/app';

export function resolveOnlineGameId(userData?: UserData | null) {
  if (!userData) return undefined;
  if (userData.currentOnlineGameId) return userData.currentOnlineGameId;

  // Legacy single-slot field — only treat as online if it is not a bot/local game
  const legacy = userData.currentGameId;
  if (!legacy) return undefined;
  if (legacy === userData.currentBotGameId || legacy === userData.currentLocalGameId) {
    return undefined;
  }
  return legacy;
}

export function playerIsInGameId(userData: UserData | undefined, gameId: string) {
  if (!userData || !gameId) return false;
  return (
    userData.currentBotGameId === gameId ||
    userData.currentLocalGameId === gameId ||
    userData.currentOnlineGameId === gameId ||
    userData.currentGameId === gameId
  );
}
